import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import { formateDateYYYYMMDD } from '../common/timeUtil.js';

export const DatePicker = createReactClass({
    propTypes: {
        onSelect: PropTypes.func.isRequired,
        requestedExtensionDate: PropTypes.string,
        projectId: PropTypes.number,
        loggedInUser: PropTypes.bool,
        dateError: PropTypes.string,
    },

    getInitialState() {
        return { currentDueDate: null };
    },

    componentDidMount() {
        this.setupDatePicker();
    },

    componentDidUpdate: function (prevProps) {
        if (this.props.loggedInUser) {
            if (!(this.props.loggedInUser === prevProps.loggedInUser && this.props.projectId === prevProps.projectId)) {
                this.setupDatePicker();
            }
        }
    },

    setupDatePicker() {
        if (this.props.loggedInUser && this.props.projectId) {
            this.setupCalendarForLoggedInUser(this.props.projectId).then((result) => {
                if (result.permittedDates) {
                    this.setupCalendar(result.permittedDates);
                    this.setCurrentDueDate(result.feedbackDate);
                } else {
                    this.setupCalendarForLoggedInUser(null).then((result) => {
                        this.setupCalendar(result.permittedDates);
                        this.setCurrentDueDate(result.feedbackDate);
                    });
                }
            });
        } else {
            this.setupCalendarForNonLoggedInUser().then((result) => {
                this.setupCalendar(result.permittedDates);
                this.setCurrentDueDate(result.feedbackDate);
            });
        }
    },

    setCurrentDueDate(currentDueDate) {
        this.setState({
            currentDueDate: currentDueDate,
        });
    },

    setupCalendar(permittedDates) {
        var component = this;
        $('#extension-date-picker').datepicker('destroy');
        $('#extension-date-picker').datepicker({
            dateFormat: 'mm-dd-yy',
            onSelect: function (newDate) {
                var event = { target: { name: 'requestedExtensionDate', value: newDate } };
                component.props.onSelect(event);
            },

            // This function determines which dates should be selectable. It must return an array
            // whose first item is a boolean.
            beforeShowDay: function (date) {
                return [!!permittedDates[formateDateYYYYMMDD(date)]];
            },
        });
    },

    setupCalendarForNonLoggedInUser() {
        return $.ajax({
            url: '/common/get_permitted_dates_for_project_feedback_due_date_extension.html',
            dataType: 'json',
        });
    },

    setupCalendarForLoggedInUser(projectId) {
        if (projectId !== 0 && projectId !== null) {
            return $.ajax({
                url: '/common/get_permitted_dates_for_project_feedback_due_date_extension.html?projectId=' + projectId,
                dataType: 'json',
            });
        } else {
            return $.ajax({
                url: '/common/get_permitted_dates_for_project_feedback_due_date_extension.html',
                dataType: 'json',
            });
        }
    },

    render() {
        var currentDueDate = (this.state.currentDueDate ? this.state.currentDueDate : 'Not Available');
        return (<div className="input-holder">
            <label>Current Due Date: {currentDueDate}</label>
            <label>Request a new due date:
                <p id="blockedDatesCalendarNote">Dates are blocked that are either in the past or around
							the time of your school's Thanksgiving and winter breaks. <br/> Using the calendar below,
							select a due date when your students will be in attendance.<br/>
                </p>
            </label>
            <div className="input-holder calendar-holder">
                <input type="text" name="requestedExtensionDate" id="extension-date-picker" value={this.props.requestedExtensionDate} readOnly="true"
							   className={this.props.dateError ? 'hasError date-picker date-entry' : 'date-picker date-entry'} placeholder="MM-DD-YYYY"/>
                {this.props.dateError ? (<div className="error-text">{this.props.dateError}</div>) : null}
            </div>
        </div>
        );
    },
});
